import {observable} from 'mobx';
import {createContext, useContext} from "react";
import mutationObserver from 'utils/mutation_observer';

let SELECTOR = '[data-paywall-config]';

export const paywallStore = observable({
    views: {
        remaining: 0,
        total: 0,
        get used() {
            return this.total - this.remaining;
        },
        get unlimited() {
            return this.remaining < 0;
        },
    },
    registrationWall: {
        enabled: undefined,
        registeredEmail: null,
        get hasRegistered() {
            return this.registeredEmail !== null;
        }
    },
    subscription: {
        userHasOnlineCirculationSubscription: false,
    }
});

function parseConfig (element) {
    const config = JSON.parse(element.dataset['paywallConfig']);
    paywallStore.views.remaining = config.views.remaining;
    paywallStore.views.total = config.views.total;
    paywallStore.registrationWall.enabled = config.registration_wall_enabled;
    paywallStore.subscription.userHasOnlineCirculationSubscription = config.user_has_online_circulation_subscription;
}

for (let el of document.querySelectorAll(SELECTOR))
    parseConfig(el);

mutationObserver(SELECTOR, (element) => {
    parseConfig(element);
})


export const usePaywallStoreContext = () => useContext(createContext(paywallStore));
